export const timeOut = {
	//time in seconds
	resendOTP: 30
}